import { Tags } from './pages/tags';
import { TopicAdd } from './pages/topic-add';
import { TopicView } from './pages/topic-view';

/**
 * Initialise pages
 */
(() => {
    const dataElement = document.querySelector('[data-page]');
    const page = dataElement ? dataElement.dataset.page : '';
    const className = page.replace(/-./, s => s[1].toUpperCase());

    const pages = {
        tags: Tags,
        topicAdd: TopicAdd,
        topicView: TopicView
    };

    // FIXME remove
    // set the page title
    // const title = dataElement ? dataElement.dataset.title : '';
    // if(title) {
    //     const originalTitle = document.title;
    //     document.title = title + ' | ' + originalTitle;
    // }

    // initialise page specific code
    if(pages[className]) {
        const pageObject = new pages[className]();
        pageObject.init();
    }

    // convert date / time to local variant
})();
